<template>
    <div ref="unitEntryByCustomerLocation" style="min-height: 500px;"></div>
</template>

<script>
    /* Imports */
    import * as am4core from "@amcharts/amcharts4/core";
    import * as am4charts from "@amcharts/amcharts4/charts";
    import am4themes_animated from "@amcharts/amcharts4/themes/animated";

    export default {
        data() {
            return {
                chart: null,
            }
        },
        props: ['data'],
        mounted() {
            this.createChart();
            this.generateData();
        },
        watch: {
            data: {
                deep: true,
                handler: 'generateData'
            }
        },
        methods: {
            generateData() {
                let length = this.chart.data.length;

                this.chart.addData(this.data && this.data.length > 0 ? this.data : [{
                    "customer_location": "No Data",
                    "same_region": 0,
                    "different_region": 0
                }], length)
            },
            createChart() {
                /* Chart code */
                // Themes begin
                am4core.useTheme(am4themes_animated);
                // Themes end

                // Create chart instance
                this.chart = am4core.create(this.$refs.unitEntryByCustomerLocation, am4charts.XYChart);

                // Create axes
                let categoryAxis = this.chart.xAxes.push(new am4charts.CategoryAxis());
                categoryAxis.dataFields.category = "customer_location";
                categoryAxis.renderer.grid.template.location = 0;


                let valueAxis = this.chart.yAxes.push(new am4charts.ValueAxis());
                valueAxis.renderer.inside = true;
                valueAxis.renderer.labels.template.disabled = true;
                valueAxis.min = 0;

                this.createSeries("same_region", "Same Location");
                this.createSeries("different_region", "Different Location");

                // Legend
                this.chart.legend = new am4charts.Legend();
            },
            createSeries(field, name) {

                // Set up series
                let series = this.chart.series.push(new am4charts.ColumnSeries());
                series.name = name;
                series.dataFields.valueY = field;
                series.dataFields.categoryX = "customer_location";
                series.sequencedInterpolation = true;

                // Make it stacked
                series.stacked = true;

                // Configure columns
                series.columns.template.width = am4core.percent(60);
                series.columns.template.fillOpacity = .8;
                series.columns.template.tooltipText = "[bold]{name}[/]\n[font-size:14px]{categoryX}: {valueY}";

                // Add label
                let labelBullet = series.bullets.push(new am4charts.LabelBullet());
                labelBullet.label.text = "{valueY}";
                labelBullet.locationY = 0.5;
                labelBullet.label.hideOversized = true;

                return series;
            }
        }
    }
</script>

<style scoped>

</style>